import { ScrollTrigger } from "gsap/ScrollTrigger";

import initGsapRevealer from "./triggers/gsapRevealer";
import initGsapAos from "./triggers/gsapAos";
import initGsapIsElementSticked from "./triggers/gsapIsElementSticked";
import initGsapIsElementInview from "./triggers/gsapIsElementInview";
import initGsapGetScrollDirection from "./triggers/gsapGetScrollDirection";
import initGsapSticker from "./triggers/gsapSticker";
import initgsapSwapBackground from "./triggers/gsapSwapBackground";

export default function initTriggers() {
    if (!ScrollTrigger.isTouch) initGsapRevealer();
    initGsapAos();
    initGsapIsElementSticked("#site-header");
    initGsapIsElementInview("#site-footer");
    initGsapGetScrollDirection();
    initgsapSwapBackground();

    // setTimeout is only required because of Elementor x Lottie Integration
    setTimeout(() => {
        initGsapSticker();
    }, 200);
}
